import { KINETIC_MODULES, LazyComponent, ModuleImports } from './modules';
import { useLicensedModules } from './useLicensedModules';
import { useMemo } from 'react';

type UseLazyModuleImportsOptions = {
  imports: ModuleImports<LazyComponent>;
  pick?: KINETIC_MODULES[];
  omit?: KINETIC_MODULES[];
};

/**
 * Returns dynamic module imports filtered by license, and optionally array passed to `pick`
 */
export const useLazyModuleImports = ({ imports, pick, omit }: UseLazyModuleImportsOptions) => {
  const licensedModules = useLicensedModules();

  const lazyImports = useMemo(() => {
    return Object.keys(imports).reduce((acc, key) => {
      const uiModuleName = key as Exclude<keyof typeof imports, '__missing'>;
      if (
        !licensedModules.includes(uiModuleName) ||
        (pick && !pick.includes(uiModuleName)) ||
        (omit && omit.includes(uiModuleName))
      ) {
        return acc;
      }

      acc[uiModuleName] = imports[uiModuleName];
      return acc;
    }, {} as ModuleImports<LazyComponent>);
  }, [imports, licensedModules, omit, pick]);

  return lazyImports;
};
